import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
    },
    outlined: {
        borderRadius: '5px', //theme.borqader.medium.radius,
        borderWidth: '1px', //theme.border.medium.width,
        borderColor: theme.palette.primary.main,
        borderStyle: 'solid', //theme.border.medium.style,
    },
}));

export default useStyles;
